module.exports = {"MODAL":{"FOOTER":{"DISMISS":"Ignora","SAVE":"Salva"}}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/it/modal.json
// module id = 720
// module chunks = 0